import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";
import { PageSeo } from "../components/seo/page-seo";
import DesktopArchive from "../components/archive/desktop-archive";
import MobileArchive from "../components/archive/mobile-archive";

const Archive = ({ data }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 860);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Filter out current exhibition
  const items = data.allPrismicExhibition.nodes.filter((item) => {
    if (data.prismicHome.data.current_exhibition.document !== null) {
      return item.id !== data.prismicHome.data.current_exhibition.document.id;
    } else {
      return item;
    }
  });

  return (
    <>
      <PageSeo seoTitle={`Archive`} seoText={null} seoImage={null} />
      {isMobile ? (
        <MobileArchive items={items} />
      ) : (
        <DesktopArchive items={items} />
      )}
    </>
  );
};

export default withPrismicPreview(Archive);

export const query = graphql`
  query {
    prismicHome {
      data {
        current_exhibition {
          document {
            ... on PrismicExhibition {
              id
            }
          }
        }
      }
    }
    allPrismicExhibition(sort: { fields: data___start_date, order: DESC }) {
      nodes {
        id
        url
        data {
          title {
            richText
            text
          }
          artist {
            richText
            text
          }
          additional_info {
            richText
          }
          start_date
          end_date
          desktop_thumbnail {
            gatsbyImageData(layout: FULL_WIDTH, width: 1000)
            alt
            dimensions {
              width
              height
            }
          }
        }
      }
    }
  }
`;
